module.exports = __webpack_public_path__ + "media/images/ui__arrowRightInactive-16b45553b2be0dd84884d3f72722c6d9.png";